"use client";

import React from "react";
import Image from "next/image";
import EventDateTime from "./EventDateTime";

interface PagesBannerProps {
  data: {
    bannerData: {
      bannerUrl: string;
      bannerAlt: string;
    };
    formLink: string | null;
    statisticsStrip: {
      learners: string;
      duration: string;
      found_it_useful: string;
    };
    eventDateAndTime: {
      date: string;
      time: string;
    };
  };
  eventMetaData: {
    courseId: number;
    courseName: string;
    eventId: string;
    eventType: string;
    zoomWebinarId: string;
    eventName: string;
    city_id: number;
    city: "string";
    orientation_id: number;
  };
}

const PagesBannerNewMob: React.FC<PagesBannerProps> = ({ data }) => {
  return (
    <>
      <div className="w-full h-auto relative bg-[#F5F5F5]">
        {/* Background Image with Blur Effect */}
        <div className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none">
          <Image
            src={data.bannerData.bannerUrl}
            alt={data.bannerData.bannerAlt || "Background"}
            className="w-full h-full object-cover"
            fill
            priority
            sizes="100vw"
          />
          {/* Blur Overlay */}
          <div
            className="absolute inset-0"
            style={{
              background: "rgba(4, 16, 28, 0.12)",
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
            }}
          />
        </div>

        <div className="relative z-20 flex flex-col items-center justify-center px-4 pt-8 pb-16 md:py-12">
          <div className="w-full flex justify-center items-center mb-6">
            <Image
              src={data.bannerData.bannerUrl}
              alt={data.bannerData.bannerAlt || "Event Banner Image"}
              className="max-w-full h-auto rounded-lg shadow-lg"
              width={600}
              height={400}
              priority
            />
          </div>

          <div className="absolute w-full flex justify-center items-center mt-[82%]">
            <Image
              src="/events/frame-desk.png"
              alt="events_frame"
              className="w-[340px] h-[110px] md:h-auto md:w-[400px] lg:w-[609px] pointer-events-none"
              width={609}
              height={80}
              priority
            />

            <div className="absolute bottom-[68%] left-[20%]">
              <EventDateTime
                date={data.eventDateAndTime?.date}
                time={data.eventDateAndTime?.time}
              />
            </div>

            <div className="absolute mt-1 inset-3 flex justify-center mx-auto items-center px-2 w-[340px] md:w-[400px] lg:w-[609px] h-full pointer-events-none z-10">
              <div className="flex-1 text-center ">
                <h3 className="text-[16px] md:text-[18px] font-bold text-[#030F1C]">
                  {data.statisticsStrip.learners}
                </h3>
                <p className="text-xs text-[#6B7280]">Learners</p>
              </div>

              <div className="flex-1 text-center">
                <h3 className="text-[16px] md:text-[18px] font-bold text-[#030F1C]">
                  {data.statisticsStrip.duration}
                </h3>
                <p className="text-xs text-[#6B7280]">Duration (mins)</p>
              </div>

              <div className="flex-1 text-center ">
                <h3 className="text-[16px] md:text-[18px] font-bold text-[#030F1C]">
                  {data.statisticsStrip.found_it_useful}
                </h3>
                <p className="text-xs text-[#6B7280]">Found It Useful</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PagesBannerNewMob;
